export const isOfferTimeslotAvailable = (totalPriceData: any): boolean => {
  return !!(totalPriceData && totalPriceData?.status === "available");
};
